export const COUNTRY_CODE = {
  ARGENTINA: 'AR',
  BRAZIL: 'BR',
  MEXICO: 'MX',
  ARUBA: 'AW',
  CURACAO: 'CW',
  UNITED_STATES: 'US'
};
